import { myResourceTypeBindingsService } from 'v5/services/internal/ResourceTypeBindingsService/ResourceTypeBindingsService.connected';
import { createMetastructureMappingService } from './MetastructureMappingService.impl';

export const myMetastructureMappingService = createMetastructureMappingService({
  resourceTypeBindingsService: myResourceTypeBindingsService
});
